import { render } from "./Home.vue?vue&type=template&id=7dbea866&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=7dbea866&scoped=true&lang=scss"

import exportComponent from "/Users/wangwangxinkai/Documents/PBM/tianke-1/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dbea866"]])

export default __exports__